import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQUlEQVR42n3NIQ4AMQhE0d7/lBhAAAFBgtlkNq2p64hRL/kL731rf1VBVZGZiAi4O2bmAjMDER0kImBmdPcFr8QPKvp8rhUSL58AAAAASUVORK5CYII="};
